import { render, staticRenderFns } from "./create-order-modal.vue?vue&type=template&id=c5ab5d0a&lang=pug"
import script from "./create-order-modal.vue?vue&type=script&lang=js"
export * from "./create-order-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports